<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
        class="screenInput"
        v-model="screen.title"
<<<<<<< HEAD
        placeholder="请输入标题"
=======
        placeholder="请输入名称"
>>>>>>> master
      ></el-input>
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.status"
        placeholder="请选择是否上架"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="上架" value="1"></el-option>
        <el-option label="下架" value="2"></el-option>
      </el-select>
      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px"
        >重置</el-button
      >
    </div>
    <div style="margin-top: 10px">
      <el-button
        type="primary"
        @click="addMenu(0)"
        style="margin-bottom: 5px"
        v-if="roles.includes('/place/service_add')"
        >添加</el-button
      >
    </div>

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="所属园区" min-width="220">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="名称" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="租金单价">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上下架状态" min-width="100" align="center">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.role_type == 1 ? '后台' : '小程序' }}</span> -->
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "上架" : "下架" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/place/service_edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/place/service_del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="title">
          <el-input
            :disabled="cztype == 'see'"
            class="w4"
            v-model="ruleForm.title"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="租金单价" prop="price">
          <el-input
            class="w4 numInput"
            type="number"
            :disabled="cztype == 'see'"
            v-model="ruleForm.price"
            @blur="
              ruleForm.price =
                Number(ruleForm.price
                  .replace(/[^\d|\.]/g, '')
                  .replace(/^00/g, '0')
                  .replace(/^\./g, '0.')).toFixed(2)
            "
            placeholder="请输入租金单价"
            ><template slot="append">元</template></el-input
          >
        </el-form-item>
        <el-form-item label="上下架状态" prop="content">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="2">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { openPark, delImage } from "@/api/index";
import {
  reception_room_info,
  meeting_service_add,
  meeting_service_list,
  meeting_service_del,
  meeting_service_edit
} from "@/api/sharedOffice"
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        title: "",
        status: "",
      },
      total: 0,
      ruleForm: {},
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        price: [{ required: true, message: "请输入租金单价", trigger: "blur" }],
      },
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    reset() {
      this.screen = {
        park_id: "",
        title: "",
        page: 1,
        page_size: 15,
        status: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              meeting_service_edit(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.ruleForm = {
        park_id: val.park_id,
        title: val.title,
        price: val.price,
        status: val.status,
        id:val.id
      };
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          meeting_service_del({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      // return;
      var that = this;
      // return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              meeting_service_add(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_id: "",
        title: "",
        price: "",
        status: 1,
      };
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      meeting_service_list(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin-right: 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}

.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}

.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
.tabBox {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
